import {Component, OnInit} from '@angular/core';

import {ParametersService, SubtitlesService, ZonesService} from "../../core";
import {StateService} from "@uirouter/core";

@Component({
    selector: 'valve-info',
    templateUrl: './valve-info.component.html',
    styleUrls: ['./valve-info.component.scss']
})
export class ValveInfoComponent implements OnInit {
    constructor(
        private parameters: ParametersService,
        private $state: StateService,
        private subtitles: SubtitlesService,
        public zones: ZonesService,
    ) {
    }

    ngOnInit() {
        if (this.zones.selectedZone === undefined) {
            this.$state.go('home', {selectedModuleHash: this.parameters.selectedModuleHash});
            return;
        }
        this.zones.setOverflow();
    }

    subtitle(id: number) {
        return this.subtitles.setSubtitle(id);
    }
}
